import * as Dialog from "@radix-ui/react-dialog";
import { Label } from "@radix-ui/react-label";
import React, { useRef, useState } from "react";
import styled from "styled-components";
import { RegisterUser } from "../services/userService";
import { ButtonRow, FormRow } from "./dialog";

const RegisterButton = styled.button`
  width: fit-content;
`;

const NameInput = styled.input`
  box-sizing: border-box;
  max-width: 100%;
  font-size: 5vh;
`;

export const RegistrationForm = ({
  registerUser,
  onLogin,
}: {
  registerUser: RegisterUser;
  onLogin: () => void;
}) => {
  const [valid, setValid] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const [nameInput, setNameInput] = useState("");

  // TODO: test coverage for this logic

  const submitRegistration = () => {
    registerUser({ name: nameInput }).then((response) => {
      localStorage.setItem("token", response.token);
      onLogin();
    });
  };

  return (
    <Dialog.Root modal={true} open={true}>
      <Dialog.Portal>
        <Dialog.Overlay className="DialogOverlay">
          <Dialog.Content
            ref={contentRef}
            className="DialogContent"
            aria-label={"Registration"}
            onOpenAutoFocus={(event) => {
              event.preventDefault();
              contentRef.current?.focus({ preventScroll: true });
            }}
          >
            <div>
              {/* After the concert: uncomment this message and comment out the FormRow below. */}
              {/*
              <div>
                The concert is over and registration is now disabled. We hope to
                see you again!
              </div>
              */}
              <FormRow>
                <Label className="formLabel" htmlFor={"name"}>
                  Display name
                </Label>
                <NameInput
                  id={"name"}
                  required={true}
                  autoCapitalize={"off"}
                  autoCorrect={"off"}
                  minLength={2}
                  onInput={(e) => {
                    setValid(e.currentTarget.checkValidity());
                    setNameInput(e.currentTarget.value);
                  }}
                  placeholder={"Enter your name"}
                />
              </FormRow>
              <ButtonRow>
                <RegisterButton onClick={submitRegistration} disabled={!valid}>
                  Register
                </RegisterButton>
              </ButtonRow>
            </div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
